import { createSlice } from "@reduxjs/toolkit";
import { IResaleHotelModel } from "src/interfaces";

export interface ReservationListState {
  editingProduct: IResaleHotelModel | null;
  localUploadImages: any[];
}

const initialState: ReservationListState = {
  editingProduct: null,
  localUploadImages: [],
};

const ResaleSlice = createSlice({
  name: "ResaleSlice",
  initialState,
  reducers: {
    setEditingProduct: (state, action) => {
      state.editingProduct = action.payload.product;
    },
    setLocalUploadImages: (state, action) => {
      state.localUploadImages = action.payload.images;
    },
  },
});

export const { setEditingProduct, setLocalUploadImages } = ResaleSlice.actions;
export default ResaleSlice.reducer;
